import {
  container,
//cardTitle,
//whiteColor,
//grayColor,
  ts_main
} from "assets/jss/material-dashboard-pro-react.jsx";

let mobileOpen = (window.innerWidth < 960) ? true : false; //console.log("mobileOpen="+mobileOpen);
let labelHeader_fontSize   = mobileOpen ? "1.3rem" : "1.7rem";
let labelHeader_fontWeight = mobileOpen ? "250"    : "300";
let listItem_fullName_fontSize = mobileOpen ? "0.85rem" : "1.0rem";
let HeaderMenuSearchLabel_fontSize = mobileOpen ? "0.70rem" : "0.75rem";

const BillsCategoriesStyle = theme => ({
  container: {
    ...container,
    backgroundColor: "#FFFFFF",
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0px",
      paddingBottom: "0px"
    }
  },
  labelHeader: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : labelHeader_fontSize,//"1.7rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : labelHeader_fontWeight,//"300",
    color            : "#FFDD00",
    textAlign        : "left",
  },
  label1: {
    fontSize     : "1rem",
    fontFamily   : '"Helvetica"',
    fontWeight   : "300",
    color        : "#303030",
    textAlign    : "left",
    "vertical-align":"middle",
  },
  logo: {
    margin: "1rem 0",
    "& img": {
      width: "25%",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  listItembutton:{
    display: 'inline-block',
    padding:0,
    minHeight: 0,
    minWidth: 0,
    marginTop        : 2,
    marginBottom     : 2,
    textTransform    : 'none',
    color            : "#35B6B4",
  },
  listItem_empty: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "0.8rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "100",
    color            : "#8D9A9E",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  listItem_date: {
    marginTop        : 2,
    marginBottom     : 2,
    fontSize         : "0.8rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "100",
    color            : "#8D9A9E",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  listItem_TM: {
    marginTop        : 2,
    marginBottom     : 2,
    fontSize         : "0.8rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "100",
    color            : "#8D9A9E",
    textAlign        : "right",
    "vertical-align" : "middle",
  },
  listItem_fullName: {
    marginTop        : 2,
    marginBottom     : 2,
    fontSize         : listItem_fullName_fontSize,//"1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "bold",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  listItem_amount: {
    marginTop        : 2,
    marginBottom     : 2,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "bold",
    color            : "#303030",
    textAlign        : "right",
    "vertical-align" : "middle",
  },
  listItem_currency: {
    marginTop        : 0,
    marginBottom     : 0,
    fontSize         : "0.9rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "normal",
    color            : "#303030",
    textAlign        : "right",
    "vertical-align" : "middle",
  },

  popup_label_header: {
    marginLeft       : 50,
    marginRight      : 50,
    fontSize         : "0.8rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "200",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  popup_label_close: {
    marginLeft       : 50,
    marginRight      : 50,
    fontSize         : "0.8rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "200",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  popup_label_normal_action: {
    marginLeft       : 50,
    marginRight      : 50,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "200",
    color            : "#35B6B4",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  popup_label_cancel_action: {
    marginLeft       : 50,
    marginRight      : 50,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "200",
    color            : "#ff3333",
    textAlign        : "center",
    "vertical-align" : "middle",
  },

  History_nohistory_lbl1: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.2rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "bold",
    color            : "#35B6B4",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  History_nohistory_lbl2: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  popupOkButton: {
    textTransform   : "none",
    backgroundColor : "#FFDD00",
    'border-radius' : "10px"
  },

  //----------
  //PleaseWait
  //----------
  pleaseWait: {
    marginTop        : 50,
    marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },
  //-----------
  //Header Menu
  //-----------
  HeaderMenuSearchLabel: {
    fontSize         : HeaderMenuSearchLabel_fontSize,//"0.75rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "bold",
    color            : "#35B6B4",
    textAlign        : "center",
    "vertical-align" :"middle",
    margin           : "10px 0px -5px -5px !important",
    padding          : "0px !important",
  },
  HeaderMenuImage: {
    margin: "0rem 0",
    "& img": {
    //width: "75%",
      width: "40px",
      height: "40px",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  HeaderMenuLabel: {
    fontSize     : "0.72rem",
    fontFamily   : '"Helvetica"',
    fontWeight   : "bold",
    color        : "#35B6B4",
    textAlign    : "center",
    "vertical-align":"middle",
    margin          : "0px 0px !important",
    padding         : "0px !important",
  },
});

export default BillsCategoriesStyle;
